module.exports = __webpack_public_path__ + "img/bg-icon6.32cdf32d.png";